export const messages = {
  en: {
    buyGold: {
      title: 'Purchase Coupon',
      couponName: 'Coupon Name',
      couponStock: 'Stock',
      couponPrice: 'Coupon Price',
      couponCount: 'Coupon Quantity',
      paymentAmount: 'Payment Amount',
      scanPay: 'Scan to Pay',
      wechatPayTip: 'Please scan with WeChat',
      back: 'Back',
      purchase: 'Purchase',
      cancel: 'Cancel',
      paymentComplete: 'Payment Complete',
      refresh: 'Refresh'
    }
  },
  zh: {
    buyGold: {
      title: '购买优惠券',
      couponName: '优惠券',
      couponStock: '库存',
      couponPrice: '优惠券价格',
      couponCount: '优惠券数量',
      paymentAmount: '支付金额',
      scanPay: '扫码支付',
      wechatPayTip: '请用微信扫码支付',
      back: '返回',
      purchase: '购买',
      cancel: '取消',
      paymentComplete: '支付完成',
      refresh: '刷新'
    }
  }
}